// @flow

import * as React from 'react';
import DropDownInput from './DropDownInput';
import NumberInput from './NumberInput';

import type {OptionList} from "../common/OptionManager";
import type {ComponentMeta, UnmountHandler} from "../common/CommonTypes";
import ReactAI from 'react-appinsights';

export type TubeMaterialCallback = (tubeMaterial: number) => OptionList;
export type TubeDiameterCallback = (tubeMaterial: number, tubeDiameter: number) => OptionList;

type Props = {
    namePrefix: string,
    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,
    values: {[valueName: string]: number},
    metas: {[valueName: string]: ComponentMeta},
    tubeTypes: OptionList,
    tubeMaterialCallback?: TubeMaterialCallback,
    tubeDiameterCallback: TubeDiameterCallback,
    minDiameter?: ?number,
    maxDiameter?: ?number,

    htmlHelpType?: string,
    htmlHelpMaterial?: string,
    htmlHelpDia?: string,
    htmlHelpLength?: string,

    phaseNr: number,
    
    skipTubeType?: boolean

}

const TubeInput = (props: Props) => {
    const namePrefix = props.namePrefix;
    const onChange = props.onChange;
    const onBlur = props.onBlur;
    const onUnmount = props.onUnmount;
    const values = props.values;
    const metas = props.metas;
    const tubeTypes = props.tubeTypes;
    const tubeMaterialCallback = props.tubeMaterialCallback;
    const tubeDiameterCallback = props.tubeDiameterCallback;

    const tubeTypeName = namePrefix + "TubeType";
    const tubeMaterialName = namePrefix + "TubeMaterial";
    const tubeDiameterName = namePrefix + "TubeDiameter";
    const tubeLengthName = namePrefix + "TubeLength";

    let materialValues;
    if(typeof tubeMaterialCallback !== 'undefined')
        materialValues = tubeMaterialCallback(values[tubeTypeName]);

    let diameterValues = tubeDiameterCallback(values[tubeTypeName], values[tubeMaterialName]);

    let extraClassFormGroup = "col-sm-3";
    if(typeof materialValues === 'undefined')
        if(tubeTypes.length > 0)
            extraClassFormGroup = "col-sm-4";
        else
            extraClassFormGroup = "col-sm-6";

    return (
        <div className="row">
            { tubeTypes.length > 0 && <DropDownInput htmlName={tubeTypeName}
                           onChange={onChange}
                           onBlur={onBlur}
                           onUnmount={onUnmount}
                           extraClassFormGroup={extraClassFormGroup}
                           labelText="Typ"
                           phaseNr={props.phaseNr}
                           helpHtml={props.htmlHelpType}
                           value={values[tubeTypeName]}
                           meta={metas[tubeTypeName]}
                           values={tubeTypes}
                           disabled={tubeTypes.length === 1}                          
            /> }

            { typeof materialValues !== 'undefined' && <DropDownInput htmlName={tubeMaterialName}
                                                                      onChange={onChange}
                                                                      onBlur={onBlur}
                                                                      onUnmount={onUnmount}
                                                                      extraClassFormGroup={extraClassFormGroup}
                                                                      labelText="Material"
                                                                      phaseNr={props.phaseNr}
                                                                      helpHtml={props.htmlHelpMaterial}
                                                                      value={values[tubeMaterialName]}
                                                                      meta={metas[tubeMaterialName]}
                                                                      values={materialValues} /> }

            <DropDownInput htmlName={tubeDiameterName}
                           onChange={onChange}
                           onBlur={onBlur}
                           onUnmount={onUnmount}
                           extraClassFormGroup={extraClassFormGroup}
                           labelText="Diameter (mm)"
                           phaseNr={props.phaseNr}
                           helpHtml={props.htmlHelpDia}
                           value={values[tubeDiameterName]}
                           minValue={props.minDiameter}
                           maxValue={props.maxDiameter}
                           meta={metas[tubeDiameterName]}
                           values={diameterValues} />

            <NumberInput    htmlName={tubeLengthName}
                            onChange={onChange}
                            onBlur={onBlur}
                            onUnmount={onUnmount}
                            extraClassFormGroup={extraClassFormGroup}
                            labelText="Längd (m)"
                            phaseNr={props.phaseNr}
                            helpHtml={props.htmlHelpLength}
                            value={values[tubeLengthName]}
                            meta={metas[tubeLengthName]}
                            min={0}
                            disabled={tubeLengthName !== 'existingTube1TubeLength'}
                />

        </div>
    );
};

export default ReactAI.withTracking(TubeInput);




// WEBPACK FOOTER //
// ./src/components/TubeInput.js